// Backend slugs are generated from a display name with no character sanitisation
// (`productController` does `name.replace(/\s+/g, "-").toLowerCase()`), and
// `Product.slug` is nullable. A slug containing a path or query character would
// produce a broken `<loc>` in the sitemap and an unroutable URL on the site, so
// every slug that reaches a URL must be checked first.
//
// Note we *filter* rather than encode: `@nuxtjs/sitemap` already runs
// `encodeURI` over every `loc`, so pre-encoding double-escapes `%`.
const UNSAFE_SLUG_RE = /[/?#%\s]/;

export function isSafeSlug(slug: unknown): slug is string {
  return typeof slug === "string" && slug.length > 0 && !UNSAFE_SLUG_RE.test(slug);
}
